import React, { useEffect, useState } from 'react';
import '../../assets/styles/user-profile.css';
import { useAuth } from '../../components/context/Authcontext.jsx';
import { toast } from 'react-toastify';
import FilterModal from '../../components/filter-modal.jsx';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import configModule from '../../../config.js';
import SvgContent from '../../components/svgcontent.jsx';
import Pagination from "../../components/Pagination/index.jsx";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { PropagateLoader } from 'react-spinners';
import { useLocation } from 'react-router-dom';
import { ExportButton, exportFormattedData } from '../../components/export-page.jsx';
import filtericon from '../../assets/images/filtericon.svg';
import printer from '../../assets/images/printer.svg';

function PayRoll() {
    const { user, accessMenu } = useAuth();
    const location = useLocation();
    const [buttonPermissions, setButtonPermissions] = useState({});
    const [activeButton, setActiveButton] = useState(null);
    const [needLoading, setNeedLoading] = useState(false);
    const [leadDetails, setLeadDetails] = useState([]);
    const config = configModule.config();
    const [status, setStatus] = useState("active");
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [showDateFilter, setShowDateFilter] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [isFilterHover, setIsFilterHover] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState('');
    const [detailOpen, setDetailOpen] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [detailBreakdown, setDetailBreakdown] = useState(null);

    // Load button permissions based on current path
    useEffect(() => {
        if (accessMenu && location.pathname) {
            const currentPath = location.pathname;
            const menuItem = accessMenu.find(item => item.path === currentPath);

            if (menuItem) {
                setButtonPermissions({
                    search: menuItem.search_btn === 1,
                    sort: menuItem.sort_btn === 1,
                    filter: menuItem.filter_btn === 1,
                    export: menuItem.export_btn === 1
                });
            } else {
                setButtonPermissions({});
            }
        }
    }, [accessMenu, location.pathname]);

    const getCurrentMonthRange = () => {
        const now = new Date();
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
        return { startDate: fmt(start), endDate: fmt(end) };
    };

    const [activeRange, setActiveRange] = useState(() => getCurrentMonthRange());

    const getPageDetails = async (objStatus = '') => {
        setNeedLoading(true);
        try {
            const params = new URLSearchParams();
            const range = objStatus?.startDate && objStatus?.endDate
                ? { startDate: objStatus.startDate, endDate: objStatus.endDate }
                : getCurrentMonthRange();
            setActiveRange(range);
            params.append('startDate', range.startDate);
            params.append('endDate', range.endDate);
            if (objStatus?.branch_id) params.append('branch_id', objStatus.branch_id);
            if (objStatus?.employee_id) params.append('employee_id', objStatus.employee_id);

            // Try once without refresh, fallback not needed because query computes directly
            const response = await axios.get(`${config.apiBaseUrl}salary/calculation?${params.toString()}`);
            const result = response.data;
            if (response.status === 200) {
                setLeadDetails(result.data || []);
                setShowFilterModal(false);
            } else {
                toast.error("Failed to fetch data list: " + result.message);
            }
        } catch (error) {
            setLeadDetails([]);
            toast.error("Error fetching data list: " + (error.response?.data?.message || error.message));
        } finally {
            setNeedLoading(false);
        }
    };

    useEffect(() => {
        if (user) {
            getPageDetails();
        }
    }, [user]);

    const formatDateTime = (date) => {
        const d = new Date(date);
        if (isNaN(d.getTime())) return "Invalid date";
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    };

    const formatApiDate = (dateObj) => {
        if (!dateObj || isNaN(dateObj.getTime())) return null;
        const y = dateObj.getFullYear();
        const m = String(dateObj.getMonth() + 1).padStart(2, '0');
        const d = String(dateObj.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const filteredLeads = leadDetails
        // hide admin rows
        .filter(item => (item?.designation || '').toLowerCase() !== 'admin')
        .filter((item) => {
            const matchSearch = `${item.emp_id} ${item.name} ${item.designation} ${item.branch_name || ''}`
                .toLowerCase()
                .includes(searchQuery.toLowerCase());
            return matchSearch;
        });

    const indexOfLastLeads = currentPage * itemsPerPage;
    const indexOfFirstLeads = indexOfLastLeads - itemsPerPage;
    const currentData = filteredLeads.slice(indexOfFirstLeads, indexOfLastLeads);

    const handleExport = (data) => {
        exportFormattedData(data, 'PayrollData');
    };

    const formatCurrency = (val) => Number(val || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const formatPermissionHours = (display, hoursNum) => {
        if (typeof display === 'string' && display.trim().length > 0) return display;
        const num = Number(hoursNum);
        if (!Number.isFinite(num)) return '-';
        const totalMinutes = Math.round(num * 60);
        const hrs = Math.floor(totalMinutes / 60);
        const mins = totalMinutes % 60;
        return `${hrs} hrs ${mins} mins`;
    };
    const formatPermissionDeductDays = (deductVal, hoursNum) => {
        const fallback = Number(hoursNum) > 2 ? 0.5 : 0;
        const num = Number.isFinite(Number(deductVal)) ? Number(deductVal) : fallback;
        return num.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
    };
    const handleRowClick = async (row) => {
        try {
            setNeedLoading(true);
            const { startDate: start, endDate: end } = activeRange || getCurrentMonthRange();
            const resp = await axios.get(`${config.apiBaseUrl}salary/calculation/${row.user_id}?startDate=${start}&endDate=${end}`);
            if (resp.status === 200) {
                const detail = resp.data?.data || resp.data?.[0] || null;
                if (!detail) {
                    toast.error("No payroll data available for that month");
                    return;
                }
                console.log('Payroll detail API response', {
                    user_id: row.user_id,
                    present_days: detail?.present_days,
                    absent_days: detail?.absent_days,
                    wfh_days: detail?.wfh_days,
                    awd_days: detail?.awd_days,
                    ewd: detail?.ewd,
                    permission_hours: detail?.permission_hours
                });
                setDetailData(detail);
                setDetailBreakdown(resp.data?.breakdown || null);
                setDetailOpen(true);
            } else {
                toast.error("Failed to fetch detail");
            }
        } catch (error) {
            toast.error("Error fetching detail: " + (error.response?.data?.message || error.message));
        } finally {
            setNeedLoading(false);
        }
    };

    // Debug: log whenever modal detail changes
    useEffect(() => {
        if (detailData) {
            console.log('Payroll modal detailData', {
                present_days: detailData.present_days,
                absent_days: detailData.absent_days,
                wfh_days: detailData.wfh_days,
                awd_days: detailData.awd_days,
                ewd: detailData.ewd,
                permission_hours: detailData.permission_hours
            });
        }
    }, [detailData]);

    const handlePrint = async (row) => {
        try {
            setNeedLoading(true);
            const { startDate: start, endDate: end } = activeRange || getCurrentMonthRange();
            const resp = await axios.get(`${config.apiBaseUrl}salary/calculation/${row.user_id}?startDate=${start}&endDate=${end}`);
            if (resp.status !== 200) {
                toast.error("Failed to fetch detail for print");
                return;
            }
            const detail = resp.data?.data || resp.data?.[0] || null;
            if (!detail) {
                toast.error("No payroll data to print for that month");
                return;
            }
            const monthLabel = detail.calc_month && detail.calc_year
                ? new Date(detail.calc_year, detail.calc_month - 1, 1).toLocaleString('en-US', { month: 'short', year: 'numeric' })
                : '';
            const fmt = (v) => Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            const safe = (v) => v ?? '-';
            const printHtml = `
<!doctype html>
<html>
<head>
  <meta charset="utf-8">
  <title>Payslip</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 24px; color: #222; }
    h2 { margin: 0 0 6px 0; }
    h4 { margin: 0 0 16px 0; color: #555; }
    .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 18px; }
    .row { display: flex; justify-content: space-between; border-bottom: 1px solid #eee; padding: 6px 0; }
    .label { color: #555; }
    .value { font-weight: 600; }
    .top { margin-bottom: 18px; }
  </style>
</head>
<body>
  <div class="top">
    <h2>Payroll Breakdown</h2>
    <h4>${safe(detail.name)} (${safe(detail.emp_id)})${monthLabel ? ' · ' + monthLabel : ''}</h4>
    <div>${safe(detail.designation)}${detail.branch_name ? ' | ' + detail.branch_name : ''}</div>
    <div><strong>Final Salary:</strong> ₹ ${fmt(detail.as2 ?? detail.total_amount ?? detail.salary ?? 0)}</div>
  </div>
  <div class="grid">
    <div class="row"><span class="label">Total Days</span><span class="value">${safe(detail.total_days)}</span></div>
    <div class="row"><span class="label">Sundays</span><span class="value">${safe(detail.sundays)}</span></div>
    <div class="row"><span class="label">Company Holidays</span><span class="value">${safe(detail.company_holidays)}</span></div>
    <div class="row"><span class="label">CWD</span><span class="value">${safe(detail.cwd)}</span></div>
    <div class="row"><span class="label">EWD</span><span class="value">${safe(detail.ewd)}</span></div>
    <div class="row"><span class="label">Present</span><span class="value">${safe(detail.present_days)}</span></div>
    <div class="row"><span class="label">Absent</span><span class="value">${safe(detail.absent_days)}</span></div>
    <div class="row"><span class="label">WFH</span><span class="value">${safe(detail.wfh_days)}</span></div>
    <div class="row"><span class="label">AWD</span><span class="value">${safe(detail.awd_days)}</span></div>
    <div class="row"><span class="label">Paid Leave</span><span class="value">${safe(detail.paid_leave_days)}</span></div>
    <div class="row"><span class="label">Permission Hours</span><span class="value">${safe(detail.permission_hours_display ?? detail.permission_hours)}</span></div>
    <div class="row"><span class="label">Permission Deduct Days</span><span class="value">${safe(detail.permission_deduct_days)}</span></div>
    <div class="row"><span class="label">Base Salary</span><span class="value">₹ ${fmt(detail.base_salary ?? detail.salary ?? 0)}</span></div>
    <div class="row"><span class="label">Per Day Salary</span><span class="value">₹ ${fmt(detail.per_day_salary)}</span></div>
    <div class="row"><span class="label">AS1</span><span class="value">₹ ${fmt(detail.as1)}</span></div>
    <div class="row"><span class="label">IA Amount</span><span class="value">₹ ${fmt(detail.ia_amount ?? detail.incentive_earned)}</span></div>
    <div class="row"><span class="label">PD Amount</span><span class="value">₹ ${fmt(detail.pd_amount)}</span></div>
    <div class="row"><span class="label">AWD Amount</span><span class="value">₹ ${fmt(detail.awd_amount)}</span></div>
    <div class="row"><span class="label">AS2 (Final)</span><span class="value">₹ ${fmt(detail.as2 ?? detail.total_amount ?? detail.salary ?? 0)}</span></div>
  </div>
</body>
</html>`;
            // Render to hidden iframe to avoid popup blockers
            const iframe = document.createElement('iframe');
            iframe.style.position = 'fixed';
            iframe.style.right = '0';
            iframe.style.bottom = '0';
            iframe.style.width = '0';
            iframe.style.height = '0';
            iframe.style.border = '0';
            document.body.appendChild(iframe);
            const doc = iframe.contentWindow?.document;
            if (!doc) {
                toast.error("Print unavailable in this browser");
                document.body.removeChild(iframe);
                return;
            }
            doc.open();
            doc.write(printHtml);
            doc.close();
            iframe.onload = () => {
                try {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                } finally {
                    setTimeout(() => document.body.removeChild(iframe), 500);
                }
            };
        } catch (error) {
            toast.error("Error preparing print: " + (error.response?.data?.message || error.message));
        } finally {
            setNeedLoading(false);
        }
    };

    useEffect(() => {}, [detailData]);

    const closeDetail = () => {
        setDetailOpen(false);
        setDetailData(null);
        setDetailBreakdown(null);
    };

    useEffect(() => {
        const onEsc = (e) => {
            if (e.key === 'Escape') {
                setShowFilterModal(false);
                setIsFilterHover(false);
            }
        };
        if (showFilterModal) document.addEventListener('keydown', onEsc);
        return () => document.removeEventListener('keydown', onEsc);
    }, [showFilterModal]);

    const onFilterDataFunc = (items) => {
        setSelectedFilters(items);
        getPageDetails(items);
    };

    const handleReset = () => {
        setSelectedFilters('');
        getPageDetails();
        setActiveButton(null);
    };

    return (
        <div className='common-body-st'>
            {needLoading && (
                <div className='loading-container w-100 h-100'>
                    <PropagateLoader
                        height="100"
                        width="100"
                        color="#0B9346"
                        radius="10"
                    />
                </div>
            )}
            <div className='header-div-el'>
                <div className='header-divpart-el gap-2'>
                    <p className='mb-0 header-titlecount-el'>Total employee : {filteredLeads.length || 0}</p>
                </div>

                <div className="search-add-wrapper">
                    {buttonPermissions.search && (
                        <input
                            type="text"
                            placeholder="Search"
                            className="search-input-up"
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    )}
                    {buttonPermissions.sort && (
                        <button className="btn-top-up" onClick={() => setShowDateFilter(!showDateFilter)} >
                            <SvgContent svg_name="btn_calendar" width={20} height={20} />
                            <span className='visible-label-up'>Sort</span>
                        </button>
                    )}
                    {showDateFilter && buttonPermissions.sort && (
                        <div className="date-filter-popup">
                            <DatePicker
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                placeholderText="DD/MM/YYYY"
                                className="form-control form-btncontrol-up mb-2"
                            />
                            <DatePicker
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                minDate={startDate}
                                placeholderText="DD/MM/YYYY"
                                className="form-control form-btncontrol-up mb-3"
                            />
                                <button
                                    className="btn btn-sm btn-primary w-100 apply-filter-st"
                                    onClick={() => {
                                        const start = formatApiDate(startDate);
                                        const end = formatApiDate(endDate);
                                        setCurrentPage(1);
                                        setShowDateFilter(false);
                                        getPageDetails({
                                            startDate: start,
                                            endDate: end
                                        });
                                    }}
                                >
                                    Apply Filter
                                </button>
                        </div>
                    )}
                    {buttonPermissions.filter && (
                        <div className='filter-container-up position-relative'>
                            <button
                                className={`product-filter-btns ${activeButton === 'filter' ? 'active' : ''}`}
                                style={{ color: (activeButton === 'filter' || isFilterHover) ? '#ffffff' : '#0B9346',padding:'7px 15px' }}
                                onClick={() => { setShowFilterModal(true); setActiveButton('filter'); }}
                                onMouseEnter={() => setIsFilterHover(true)}
                                onMouseLeave={() => setIsFilterHover(false)}
                            >
                                 <img src={filtericon} alt="img" style={{ filter: (activeButton === 'filter' || isFilterHover) ? 'invert(1) brightness(2)' : 'none' }} />
                            <span style={{ marginLeft: 6, color: (activeButton === 'filter' || isFilterHover) ? '#ffffff' : '#0B9346' }}>Filter</span> 
                            </button>

                            {activeButton === 'filter' && (
                                <button className='filter-clear-st' onClick={handleReset} >
                                    &times;
                                </button>
                            )}
                        </div>
                    )}

                    {buttonPermissions.export && (
                        <div className="filter-container-up">
                            <ExportButton
                                data={currentData}
                                fileName="ExpensesData"
                                onExport={handleExport}
                                disabled={!currentData || currentData.length === 0}
                            />
                        </div>
                    )}

                </div>
            </div>

            <div className='phone-header-div-el'>
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <p className='mb-0 header-titlecount-el'>Total user profiles : 1050</p>
                    <div className='d-flex gap-2'>
                        <button className="btn-top-up"><SvgContent svg_name="btn_calendar" width={20} height={20} /></button>
                        <button className="btn-top-up"><SvgContent svg_name="btn_filter" width={20} height={20} /></button>
                        <button className="btn-top-up"><SvgContent svg_name="btn_upload" width={20} height={20} /></button>
                    </div>
                </div>

                <div className="search-add-wrapper justify-content-between mb-3">
                    <div className="status-toggle-up">
                        <label htmlFor="status-active-mobile" className="custom-radio">
                            <input
                                type="radio"
                                name="mbstatus"
                                id="status-active-mobile"
                                value="active"
                                checked={status === "active"}
                                onChange={(e) => setStatus(e.target.value)}
                            />
                            <span className="radio-button"></span> Active : 920
                        </label>

                        <label htmlFor="status-inactive-mobile" className="custom-radio">
                            <input
                                type="radio"
                                name="mbstatus"
                                id="status-inactive-mobile"
                                value="inactive"
                                checked={status === "inactive"}
                                onChange={(e) => setStatus(e.target.value)}
                            />
                            <span className="radio-button"></span> In-active : 130
                        </label>
                    </div>
                    {buttonPermissions.search && (
                        <input
                            type="text"
                            placeholder="Search"
                            className="search-input"
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    )}
                </div>
            </div>

            <div className='body-div-el'>
                <div className='w-100 p-2 d-flex justify-content-center align-items-start' style={{ height: "calc(100% - 48px)" }}>
                    <div className='table-userpro-up w-100 h-100 overflow-auto'>
                        <div className='table-head-up d-flex'>
                            <div className='w-8 p-2 d-flex justify-content-center align-items-center'>S.No</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-12 p-2 d-flex justify-content-center align-items-center'>Emp ID</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-18 p-2 d-flex justify-content-center align-items-center'>Name</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-18 p-2 d-flex justify-content-center align-items-center'>Designation</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-20 p-2 d-flex justify-content-center align-items-center'>Branch</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-12 p-2 d-flex justify-content-center align-items-center'>Month</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-20 p-2 d-flex justify-content-center align-items-center'>Final Salary</div><span style={{ color: "#129347" }}> | </span>
                            <div className='w-10 p-2 d-flex justify-content-center align-items-center'>Print</div>
                        </div>
                        <div className='table-body-up d-flex'>
                            {currentData.length > 0 ? (
                                currentData.map((item, index) => (
                                    <div
                                      className='table-bodydiv-up '
                                      style={{padding :'0px ' ,minHeight:'55px' ,textAlign:'center', cursor:'pointer'}}
                                      key={item.user_id || index}
                                      onClick={() => handleRowClick(item)}
                                    >
                                        <div className='w-8 p-2 d-flex justify-content-center align-items-center'>
                                            {(currentPage - 1) * itemsPerPage + index + 1}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-12 p-2 d-flex justify-content-center align-items-center'>
                                            {item.emp_id || '-'}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-18 p-2 d-flex justify-content-center align-items-center'>
                                            {item.name || '-'}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-18 p-2 d-flex justify-content-center text-center align-items-center'>
                                            {item.designation || '-'}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div  className='w-20 p-2 d-flex justify-content-center align-items-center branch_name-st'>
                                            {item.branch_name || '-'}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-12 p-2 d-flex justify-content-center align-items-center'>
                                            {item.calc_month && item.calc_year
                                                ? new Date(item.calc_year, item.calc_month - 1, 1).toLocaleString('en-US', { month: 'short', year: 'numeric' })
                                                : '-'}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-20 p-2 d-flex justify-content-center align-items-center'>
                                            ₹ {formatCurrency(Number(item.as2 ?? item.total_amount ?? item.salary ?? 0))}
                                        </div><span style={{ color: "#ffffffff" }}> | </span>
                                        <div className='w-10 p-2 d-flex justify-content-center align-items-center'>
                                            <button
                                                className="btn btn-link p-0"
                                                style={{ textDecoration: 'none', fontWeight: 600 }}
                                                aria-label="Print payslip"
                                                title="Print payslip"
                                                onClick={(e) => { e.stopPropagation(); handlePrint(item); }}
                                            >
                                                <img src={printer} alt="print" style={{ width: 18, height: 18, filter: 'invert(29%) sepia(80%) saturate(394%) hue-rotate(94deg) brightness(94%) contrast(92%)' }} />
                                            </button>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='w-100 p-3 text-center text-muted'>No data found</div>
                            )}
                        </div>
                    </div>
                </div>

                <div className='footer-tab-st'>
                    <label htmlFor="hfg" className="me-2">
                        Results per page{" "}
                        <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="row-per-page-select"
                            style={{ width: "60px" }}
                        >
                            <option value={15}>15</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </label>
                    <Pagination
                        count={filteredLeads.length}
                        page={currentPage}
                        pageSize={itemsPerPage}
                        onChange={(pageNo) => setCurrentPage(pageNo)}
                    />
                </div>
            </div>


            {showFilterModal && (
                <FilterModal onFilterData={onFilterDataFunc} selectedFilters={selectedFilters}
                    onClose={() => { setShowFilterModal(false); setActiveButton(null); }}
                />
            )}

            {detailOpen && (
                <div className="cal-modal-overlay modal-overlay-position">
                    <div className="modal-container" style={{ maxWidth: "980px", width: "90vw" }}>
                        <div className="modal-header mb-3 d-flex justify-content-between align-items-center">
                            <h5 className="mb-0 fw-bold">Payroll Breakdown</h5>
                            <button className="cancel-button" onClick={closeDetail}>Close</button>
                        </div>
                        <div className="modal-body-cal" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                            {detailData && (
                                <div className="mb-3">
                                    <p className="mb-1 fw-semibold">{detailData.name} ({detailData.emp_id})</p>
                                    <p className="mb-1 text-muted">{detailData.designation} | {detailData.branch_name || 'Branch N/A'}</p>
                                    <p className="mb-1 fw-semibold">Final Salary: ₹ {formatCurrency(
                                        detailData.as2 ?? detailData.total_amount ?? detailData.salary ?? 0
                                    )}</p>
                                </div>
                            )}
                            <div className="row g-2">
                                {(() => {
                                    const money = (v) => `₹ ${formatCurrency(Number(v || 0))}`;
                                    const perDaySalary = Number(detailData?.per_day_salary) || 0;
                                    const paidLeaveDays = Number(detailData?.paid_leave_days) || 0;
                                    const paidLeavePay = perDaySalary * paidLeaveDays;
                                    const as1Val = Number(detailData?.as1) || 0;
                                    const pdVal = Number(detailData?.pd_amount) || 0;
                                    const iaVal = Number(detailData?.ia_amount ?? detailData?.incentive_earned) || 0;
                                    const as2Val = Number(detailData?.as2 ?? detailData?.total_amount ?? detailData?.salary ?? 0) || 0;

                                    const displayVal = (v, money = false) => {
                                        const valNum = Number(v ?? 0);
                                        if (money) return `₹ ${formatCurrency(valNum)}`;
                                        if (Number.isFinite(valNum)) {
                                            const decimals = Number.isInteger(valNum) ? 0 : 2;
                                            return valNum.toLocaleString('en-IN', { maximumFractionDigits: decimals, minimumFractionDigits: decimals });
                                        }
                                        if (typeof v === 'string' && v.trim().length > 0) return v;
                                        return '-';
                                    };
                                    const items = [
                                        ['Total Days', detailData?.total_days],
                                        ['Sundays', detailData?.sundays],
                                        ['Company Holidays', detailData?.company_holidays],
                                        ['Company Working Day', detailData?.cwd],
                                        ['Emp Working Day', detailData?.ewd_display ?? detailData?.ewd],
                                        ['Present', detailData?.present_days],
                                        ['Absent', detailData?.absent_days],
                                        ['Work From Home', detailData?.wfh_days],
                                        ['Additional Working Day', detailData?.awd_days],
                                        ['Paid Leave', detailData?.paid_leave_days],
                                        ['Permission Hrs', detailData?.permission_hours_display ?? formatPermissionHours(detailData?.permission_hours_display, detailData?.permission_hours)],
                                        ['Late Login Hrs', detailData?.late_login_hours_display ?? '00 hrs 00 mins'],
                                        ['Permission Deduct Days', formatPermissionDeductDays(detailData?.permission_deduct_days, detailData?.permission_hours)],
                                        ['Base Salary', detailData?.base_salary ?? detailData?.salary, true],
                                        ['Per Day Salary', detailData?.per_day_salary, true],
                                        ['Actual Salary', detailData?.as1, true],
                                        ['Paid Leave Pay', paidLeavePay, true],
                                        ['Incentive Amount', detailData?.ia_amount ?? detailData?.incentive_earned, true],
                                        ['Permission Deduct Amount', detailData?.pd_amount, true],
                                        ['Final Salary', detailData?.as2 ?? detailData?.total_amount ?? detailData?.salary, true],
                                    ];          
                                    const formulaLine = `Final Salary = Actual Salary + Paid Leave - Permission Deduct + Incentive Amount`;
                                    const formulaValues = `${money(as2Val)} = ${money(as1Val)} + ${money(paidLeavePay)} - ${money(pdVal)} + ${money(iaVal)} `;
                                    return (
                                        <>
                                            <div className="col-12">
                                                <div className="border rounded p-3 bg-light">
                                                    <div className="fw-semibold">{formulaLine}</div>
                                                    <div className="text-muted mt-1">{formulaValues}</div>
                                                </div>
                                            </div>
                                            {items.map(([label, val, isMoney], idx) => (
                                                <div className="col-6" key={idx}>
                                                    <div className="border rounded p-2 d-flex justify-content-between">
                                                        <span>{label}</span>
                                                        <span>{displayVal(val, isMoney)}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PayRoll;
